<template>
  <div>
    <vue-calendar
      :show-limit="3"
      :disable="disabledDays"
      :highlight="highlightedDays"

      @day-clicked="dayClicked"
      @month-changed="monthChanged"

      ref="calendarObj"
    ></vue-calendar>
    <div class="calendar-key">
      <div class="option">Available</div>
      <div class="option highlight">Contact Us</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnlineBooking',
  props: [
    'disabledDays',
    'highlightedDays',
    'calendarLoaded'
  ],
  methods: {
    dayClicked(day) {
      console.log(day);
      var dayDateObj = new Date(day.date)

      // route this to the trips list with the date that was clicked
      if(this.dateInArray(this.disabledDays.dates, dayDateObj)){
        // this date is disabled, do nothing
      } else if(this.dateInArray(this.highlightedDays.dates, dayDateObj)){
        // this date is highlighted, take them to the contact form
        this.$router.push('/show-date/'+dayDateObj.toISOString().slice(0,10));
      } else if(!day.isCurrentMonth){
        // this date is not in the current month, do nothing
      } else {
        // this date is good, take them to the list
        this.$router.push('/show-date/'+dayDateObj.toISOString().slice(0,10));
      }
    },
    monthChanged(start, end) {
      // get the new data for the new month
      this.$emit('load-month-days', start, end)
      if(this.calendarLoaded){
        this.$emit('update-selected-month', start)
      }
    },
    dateInArray(array, value) {
      return array.find(item => {return item.getTime() == value.getTime()});
    },
  },
  mounted() {
    this.$nextTick(function () {
      var selectedMonth = localStorage.getItem('selectedMonth')
      if(selectedMonth !== null) {
        this.$refs.calendarObj.$children[0].monthStart = new Date(selectedMonth)
      }
      this.$emit('set-calendar-loaded', true)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OnlineBooking.vue